import React, { useState, useEffect, useMemo, useRef } from 'react';
import axios from 'axios';
import DashboardLayout from '../Dashboard/layout';
import Swal from 'sweetalert2';
import JoditEditor from 'jodit-react';
import './PrivacyPolicy.css';
import { Headings } from '../RegisteredUsersList/ViewRegList';

const PrivacyPolicy = () => {
  const editor = useRef(null);
  const [condition, setCondition] = useState('');
  const [isLoading, setIsLoading] = useState(true); // Renamed loading to isLoading for clarity
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}api/admin/privacy-policy`)
      .then((response) => {
        // console.log("pvesjadf",response);
        
        if (response.data.privacyPolicy && response.data.privacyPolicy.content) {
          setCondition(response.data.privacyPolicy.content);
        } else {
          setCondition('');
        }
        setIsLoading(false); 
      })
      .catch((error) => {
        const errorMessage = error.response?.data?.message || 'Failed to load Privacy Policy.';
        setError(errorMessage); // Save error for display if needed
        //Swal.fire('Error', errorMessage, 'error');
        setIsLoading(false);
      });
  }, []);

  const handleSave = async () => {
    if (!condition.trim()) {
      Swal.fire('Error', 'Privacy Policy cannot be empty', 'error');
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/admin/privacy-policy`,
        { content: condition }
      );

      if (response.status === 200 || response.status === 201) {
        Swal.fire('Success', response.data.message || 'Privacy Policy saved successfully!', 'success')
          .then(() => {
            window.location.reload();
          });
      } else {
        Swal.fire('Error', 'Something went wrong while saving the terms.', 'error');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to load Privacy Policy.';
      Swal.fire('Error', errorMessage, 'error');
    }
  };

  const config = useMemo(() => ({
    readonly: false,
    placeholder: 'Start typing...',
  }), []);

  if (isLoading) {
    return <div>Loading...</div>; // Show a loading indicator until data is fetched
  }

  return (
    <DashboardLayout>
      <section className="MainDivSec">
        <Headings headspan="Privacy" hedtext=" Policy" />

        <div className="TermEditrDiv">
          <form>
            <JoditEditor
              ref={editor}
              value={condition}
              config={config}
              tabIndex={1}
              className="TermsFormsSec"
              onChange={(newContent) => setCondition(newContent)}
            />
            <div className="SubMit">
              <button type="button" onClick={handleSave}> Save </button>
            </div>
          </form>
        </div>
      </section>
    </DashboardLayout>
  );
};

export default PrivacyPolicy;
